import classNames from 'classnames';
import React from 'react';
import * as styles from './SearchResultCards.module.scss';

const SearchResultCards = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      {...props}
      className={classNames(styles.searchResultCards, props.className)}
    />
  );
};

export default SearchResultCards;
